import axios from "axios";
import store from "../store/store.js";

const instance = axios.create();

instance.interceptors.response.use(
  function (response) {
    return response;
  }, function (error) {
    if (error.response.status === 401) {
      const msg = "The authentication token is invalid." +
        "You've been redirected.";
      store.dispatch("logOut").then(() => store.dispatch("notify", {
        msg,
        timeout: 4000
      }));
    } else if (error.response.status === 403) {
    } else {
      const msg = "Something unexpected happened. Please report a bug.";
      store.dispatch("notify", { msg });
    }
    return Promise.reject(error);
  }
);

instance.interceptors.request.use(function (config) {
  const hasParams = config.url.indexOf('?') !== -1;
  const region = store.getters.getRegion;
  config.url = hasParams ? `${config.url}&region=${region}` : `${config.url}?region=${region}`;
  return config;
}, function (error) {
  return Promise.reject(error);
}
)

export default instance;



// WEBPACK FOOTER //
// ./src/axios/axios.js